<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header bg-primary">
          <h4 class="card-title text-white mb-0">Inurance plan details</h4>
        </div>
        <div class="card-body pt-3">
          <div class="row mb-3">
            <div v-for="(item, index) in data.CT_MOTOR_INSURANCE_PLAN" :key="index" class="col-sm-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-3">
                      <h3>{{ item.TITLE }}</h3>
                    </div>
                    <div class="col-lg-6"></div>
                    <div class="col-lg-3">
                      <h5 class="font-24 font-bold text-secondary text-right">{{ $u.formatMoney(item.PREMIUM) }}</h5>
                      <button v-if="item.SELECTED" type="button" class="btn btn-lg btn-outline-primary btn-block" @click="submit"><i class="mdi mdi-cart-plus"></i> Add</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 d-flex">
              <div class="mr-auto">
                <button type="button" class="btn btn-secondary" @click="previous">Previous</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    lovs: {
      type: Object,
      default: () => {}
    }
  },
  async created() {
    await this.loadMotorPremium();
  },
  methods: {
    ...mapActions('motor', ['getOfferPremium']),
    submit() {
      this.$emit('submit');
    },
    previous() {
      this.$emit('previous');
    },
    async loadMotorPremium() {
      await this.getOfferPremium(this.data);
    }
  }
};
</script>
